<template>
  <div v-loading="globalLoading" class="outAppSetBox">
    <div class="leftContent">
      <div class="leftContentIn">
        <img
          class="topImg"
          src="https://eyao-1257303417.cos.ap-shanghai.myqcloud.com/appPreview4_png_1614923554732.png?sign=q-sign-algorithm%3Dsha1%26q-ak%3DAKIDRgoV8b001yjpmgG4PWPiX0Tr0zp9bJ8j%26q-sign-time%3D1614923554%3B1701323554%26q-key-time%3D1614923554%3B1701323554%26q-header-list%3D%26q-url-param-list%3D%26q-signature%3D63ecbc7f76676fa8314863c1471acb8b24ab8e24"
          alt=""
        />
        <h3 class="top_h">
          外部应用
          <span>拖动应用可更换应用位置</span>
        </h3>
        <div class="outApp-wrap">
          <transition-group name="flip-list" class="outApp" tag="div">
            <div
              v-for="item in list"
              :key="item.id"
              class="item"
              :class="{ active1: oldVal == item && isActive == item }"
              draggable="true"
              @dragstart="dragstart(item)"
              @dragenter="dragenter(item)"
              @dragend="dragend(item)"
              @mousedown="down()"
              @mouseup="up(item)"
            >
              <img class="appImg" :src="item.icon" alt="" />
              <p>{{ item.name }}</p>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
    <div class="rightContent">
      <h6 class="title">群发对象</h6>
      <el-form label-position="left" ref="form" :model="form" :rules="rules" label-width="102px">
        <el-form-item label="名称:" prop="name">
          <el-input
            maxlength="100"
            v-model.trim="form.name"
            placeholder="请输入名称"
            class="outAppInput"
          />
          <i classs="promptText" style="color: #909399">
            仅支持中英文和数字，字数不超过6个汉字或12个字母
          </i>
        </el-form-item>
        <el-form-item label="图标:" prop="icon">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :http-request="handleRequest"
            :on-remove="handleRemove"
          >
            <img v-if="form.icon" :src="form.icon" class="avatar" />
            <i v-else class="el-icon-plus" />
          </el-upload>
          <i classs="promptText" style="color: #909399">建议上传尺寸为80px*80px的png格式图片</i>
        </el-form-item>
        <el-form-item label="类型:">
          <el-radio-group v-model="form.type">
            <el-radio :label="10">跳转网页</el-radio>
            <el-radio :label="20">跳转小程序</el-radio>
          </el-radio-group>
        </el-form-item>
        <template>
          <!-- 网页地址 -->
          <el-form-item v-show="form.type === 10" label="网页地址:" prop="url">
            <el-input
              maxlength="100"
              v-model.trim="form.url"
              placeholder="请输入网页地址"
              class="outAppInput"
            />
            <i class="promptText">点击应用会跳转到该链接。</i>
            <i class="promptTextDetail">
              发布前请先到（小程序管理平台-开发管理-开发设置-业务域名）内下载校验文件，将该文件放置要跳转的外部系统根目录下
              ，如果未放置校验文件，仅支持预览，不能实际跳转到该网页
            </i>
          </el-form-item>
          <template>
            <el-form-item v-show="form.type === 20" label="App ID:" prop="appid">
              <el-input
                maxlength="100"
                v-model.trim="form.appid"
                placeholder="请输入App ID"
                class="outAppInput"
              />
            </el-form-item>
            <el-form-item v-show="form.type === 20" label="小程序路径:" prop="path">
              <el-input
                maxlength="100"
                v-model.trim="form.path"
                placeholder="请输入路径地址"
                class="outAppInput"
              />
              <i classs="promptText" style="color: #909399">点击应用会跳转到该链接</i>
            </el-form-item>
          </template>
        </template>
        <el-form-item></el-form-item>
      </el-form>
      <div class="btn-wrap">
        <el-button @click="showPreview">手机预览</el-button>
        <el-button type="primary" @click="onSubmit" :loading="onSubmitLoading">确定发布</el-button>
        <el-button v-show="form.id !== ''" type="danger" @click="deleteApp">删除</el-button>
      </div>
    </div>
    <!-- 手机预览弹窗 -->
    <el-dialog title="手机预览" :visible.sync="dialogVisible" width="67%" class="release-dialog">
      <div class="dialogPhone">
        <iframe v-if="form.url" class="content" scrolling="no" :src="form.url"></iframe>
        <div class="content" v-else-if="form.appid">
          <span class="contentIn">暂不支持预览小程序</span>
        </div>
      </div>
    </el-dialog>
    <!-- 删除应用确认 -->
    <el-dialog :visible.sync="delDialogVisible" :show-close="true" :center="true" width="376px">
      <div style="text-align: center">确认删除该应用吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { CosMixin } from '@/mixins/cos';
import {
  sendThis,
  delay,
  checkTitle,
  checkUrl,
  checkIcon,
  checkAppId,
  acheckAppPath,
} from './util';
import {
  UpdateLinkAppInfoApi,
  GetLinkAppInfoListApi,
  CreateLinkAppInfoApi,
  UpdateLinkAppOrderApi,
  DeleteLinkAppInfoApi,
} from '@/api/setUser';

export default {
  name: 'OutAppSet',
  mixins: [CosMixin],
  data() {
    return {
      rules: {
        name: [{ validator: checkTitle, trigger: 'blur' }],
        url: [{ validator: checkUrl, trigger: 'blur' }],
        icon: [{ validator: checkIcon, trigger: 'change' }],
        appid: [{ validator: checkAppId, trigger: 'blur' }],
        path: [{ validator: acheckAppPath, trigger: 'blur' }],
      },
      form: {
        id: '',
        name: '' /* 应用名称 */,
        icon: '' /* 图标 */,
        type: 10 /* 类型 */,
        url: '' /* 网页地址 */,
        appid: '' /* appID */,
        path: '' /* 小程序路径 */,
        status: 1,
        publish_status: 1,
      },
      list: [
        {
          id: '1',
          name: '应用1',
          icon: '',
        },
      ],
      isActive: 0,
      oldVal: 0,
      newOld: 0,
      isDrag: false,
      timmerHandle: null,
      dialogVisible: false,
      plusItem: {
        id: 'plus',
        name: '添加',
        icon: 'https://cdn.nges.tencent.com/nges_1/92104202/7e7a2251-0e12-4003-ab09-3df9f1849d86.png',
      },
      appType: false, // 类型是否小程序
      globalLoading: false,
      delDialogVisible: false,
      onSubmitLoading: false,
      isShowPreview: false,
    };
  },
  mounted() {
    sendThis(this);
    this.getThirdPartyAppListAdmin();
  },
  methods: {
    // 预览
    showPreview() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        this.dialogVisible = true;
      });
    },
    // 确认删除
    async confirm() {
      if (!this.form.id) return;
      this.globalLoading = true;
      const res = DeleteLinkAppInfoApi({
        id: this.form.id,
      });
      this.globalLoading = false;
      this.delDialogVisible = false;
      if (!res) {
        this.$message.success('删除失败，请稍后再试');
        return;
      }
      this.getThirdPartyAppListAdmin();
      this.$message.success('删除成功！');
    },
    async deleteApp() {
      if (!this.form.id) return;
      this.delDialogVisible = true;
    },
    // 管理员获取第三方应用列表
    async getThirdPartyAppListAdmin() {
      this.$data.form = this.$options.data().form;
      this.$refs.form.resetFields();
      this.globalLoading = true;
      const req = {
        page_index: 1,
        page_size: 1000,
      };
      try {
        const res = await GetLinkAppInfoListApi(req);
        this.list = JSON.parse(JSON.stringify(res.list));
        this.list.sort((a, b) => a.order - b.order);
        this.list.push(this.plusItem);
      } catch {}
      this.globalLoading = false;
    },
    down() {
      this.isDrag = false;
      this.timmerHandle = setTimeout(this.setDragTrue, 200);
    },
    up(item) {
      if (item.id === 'plus') {
        this.isShowPreview = false;
        this.$refs.form.resetFields();
        this.$data.form = this.$options.data().form;
        return;
      }
      this.isShowPreview = true;
      if (!this.isDrag) {
        clearTimeout(this.timmerHandle);
        this.$refs.form.resetFields();
        this.form = JSON.parse(JSON.stringify(item));
      } else {
        this.isDrag = false;
      }
    },
    setDragTrue() {
      this.isDrag = true;
    },
    // 上传图标
    async handleRequest(file) {
      if (!/.jpg|.png$/gi.test(file.file.name)) {
        this.$message('只支持上传jpg和png图片');
        return false;
      }
      const pattern = new RegExp(
        "[%--`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——| {}【】‘；：”“'。，、？]",
      );
      this.globalLoading = true;
      const s = file.file.name;
      let rs = '';
      for (let i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }
      const cosParams = {
        imgCosKey: `${file.file.uid}${rs}`,
        fileObject: file.file,
      };
      try {
        const res = await this.putCosObject(cosParams);
        this.form.icon = res.data;
      } catch {
        this.$message('上传失败，请稍后再试');
      }
      this.globalLoading = false;
    },
    handleRemove() {
      console.log('handleRemove!');
    },
    // 管理员更新/创建第三方应用
    onSubmit() {
      this.onSubmitLoading = true;
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.onSubmitLoading = false;
          return false;
        }
        this.globalLoading = true;
        const obj = JSON.parse(JSON.stringify(this.form));
        if (this.list.length > 1) {
          !obj.order && (obj.order = this.list[this.list.length - 2].order + 1);
        }
        let fn = null;
        if (obj.id) {
          fn = UpdateLinkAppInfoApi;
        } else {
          fn = CreateLinkAppInfoApi;
        }
        fn(obj)
          .then((res) => {
            this.globalLoading = false;
            this.onSubmitLoading = false;
            if (!res) {
              this.$message.success('提交失败，请稍后再试');
              return;
            }
            this.getThirdPartyAppListAdmin();
            this.$message.success('提交成功');
          })
          .catch(() => {
            this.globalLoading = false;
            this.onSubmitLoading = false;
            this.$message.success('提交失败，请稍后再试');
          });
      });
    },
    dragstart(val) {
      this.oldVal = val;
      this.isActive = val;
    },
    // 拖拽结束
    dragend() {
      if (this.oldVal.id === 'plus' || this.newOld.id === 'plus') return;
      if (this.oldVal !== this.newOld) {
        const oldIndex = this.list.indexOf(this.oldVal);
        const newIndex = this.list.indexOf(this.newOld);
        const newItems = [...this.list];
        // 删除老的节点
        newItems.splice(oldIndex, 1);
        // 增加新的节点
        newItems.splice(newIndex, 0, this.oldVal);
        // list结构发生变化触发transition-group的动画
        this.list = [...newItems];
        // 延迟执行
        delay(() => {
          let i = 0;
          let upList = this.list.map((item) => {
            i += 1;
            return {
              order: i,
              id: item.id,
            };
          });
          upList = upList.filter((item) => item.id !== 'plus');
          this.globalLoading = true;
          // this.$goRequestData('/EyaoSaaSBatchUpdateThirdPartyAppAdmin', {
          UpdateLinkAppOrderApi({
            list: upList,
          }).then((res) => {
            this.globalLoading = false;
            if (!res) {
              this.$message('修改失败，请稍后再试');
              return;
            }
            this.getThirdPartyAppListAdmin();
            this.$message.success('修改成功');
          });
        }, 2000);
        this.isActive = -1;
      }
    },
    // 记录移动过程中信息
    dragenter(val) {
      this.newOld = val;
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
